import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";

export function useFileAnalysis() {
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const { toast } = useToast();

  const analyzeFile = async (file: File, conversationId: string) => {
    try {
      // Get the current session to ensure we have an auth token
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) {
        throw new Error('No active session');
      }

      // First create a new conversation if one wasn't provided
      let actualConversationId = conversationId;
      if (!conversationId || conversationId === "current") {
        const { data: conversation, error: convError } = await supabase
          .from('chat_conversations')
          .insert({
            title: `Analysis of ${file.name}`,
            user_id: session.user.id
          })
          .select()
          .single();

        if (convError) throw convError;
        actualConversationId = conversation.id;
      }

      const formData = new FormData();
      formData.append('file', file);
      formData.append('conversationId', actualConversationId);

      const { data, error } = await supabase.functions.invoke('analyze-file', {
        body: formData,
        headers: {
          Authorization: `Bearer ${session.access_token}`,
        },
      });

      if (error) throw error;

      return {
        fileName: file.name,
        content: data.analysis,
        conversationId: actualConversationId
      };
    } catch (error) {
      console.error('Error analyzing file:', error);
      throw error;
    }
  };

  return {
    isAnalyzing,
    analyzeFile,
  };
}